import queryKeys from '@/constants/queryKeys';
import { validateOrgGet } from '@/services/api/requests/public-screener';
import { useQuery } from '@tanstack/react-query';

const useValidateOrg = (slug: string | null) => {


  const { isLoading, data, isError, error, isSuccess } = useQuery({
    queryKey: [queryKeys.publicScreener.validateOrg, slug],
    enabled: !!slug,
    queryFn: async () => {
      if (slug) {
        const response = await validateOrgGet(slug);
        return response;
      }
    },
  });

  return { isLoading, data, isError, error, isSuccess };
};

export default useValidateOrg;
